// extracted by mini-css-extract-plugin
export default {"root":"YPs8hv","icon":"j5SGSu","badge":"RukiYa"};